module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/X-Men-Days-of-Future-Past.346f709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/X-Men-Days-of-Future-Past.jpg
// module id = l7wp
// module chunks = 0